import React, { Component, PureComponent } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import CONSTANTS from '../../../constants'
import { setVeiculeInfos, setVeiculeKilo, CurrentStepSetAction, setFilterDealersBy } from '../../../actions/action'
import TabSection from './TabSection'
import TabInfoSection from './TabInfoSection'
import { Input, Button, Radio, Select } from '../../Forms/Forms'
import fetchApiData from '../../apiHandlers/fetchApiData'
import { pushEventToGTM } from '../../../helpers/trackerManager'
import PopUp from '../../popup/popup'
import {
  Link
} from 'react-router-dom'
import './Tabs.css'
const mapStateToProps = state => state
const mapDispatchToProps = { setVeiculeInfos, setVeiculeKilo, CurrentStepSetAction, setFilterDealersBy }

class SerieTab extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      //validFirstSection: true,
      //validSecondeSection: false,
      showPopup: false,
      showFiltersPopup: false,
      step1Loading: false,
      step1ButtonDisabled: true,
      step2ButtonDisabled: (!Object.values(this.props.store.kilo).length),
      serieInput: this.props.store.car.SerialNumber || '',
      serieCodeError: false,
      KilometrageError: false,
      kilometrage: props.store.kilo.kilometrage || this.props.store.car.Mileage || '',
      contratSerivce: (!!(Object.values(props.store.kilo).length > 0 && props.store.kilo.contratService)),
      isVehiclePC: this.props.store.car.PC === undefined ? false : this.props.store.car.PC,
      isVehicleLCV: this.props.store.car.LCV === undefined ? false : this.props.store.car.LCV,
    }
    this.isRecallCampagneActivate = !!Number(window.siteConfig.ActivateRecallCampaign);

  }

  checkKilometreValidity = (km) => {
    if (km.toString().trim().length && ((Number(km)) > 999999 || km.toString().trim().length > 6)
    ) {
      this.setState({
        step2ButtonDisabled: true,
        KilometrageError: CONSTANTS.LABELS.vehicule_step2_error_limitednumbers
      })
    }
    else if (km.toString().trim().length < 1 ||
      Number(km) > 999999
    ) {
      this.setState({
        KilometrageError: false,
        step2ButtonDisabled: true
      })
      Number(km) > 999999 || km.toString().trim().length > 6 && this.setState({
        step2ButtonDisabled: true,
        KilometrageError: CONSTANTS.LABELS.vehicule_step2_error_limitednumbers
      })
    } else if (
      km.toString().trim().length &&
      !(/^[0-9]*$/.test(km))
    ) {
      this.setState({
        step2ButtonDisabled: true,
        KilometrageError: CONSTANTS.LABELS.vehicule_step2_error_numbersonly
      })
    }
    else if (km.toString().trim().length &&
      Number(km) === 0) {
      this.setState({
        step2ButtonDisabled: true,
        KilometrageError: CONSTANTS.LABELS.vehicule_step2_error_zero
      })
    }
    else {
      this.setState({
        step2ButtonDisabled: false,
        KilometrageError: false
      })
    }
  }

  componentDidMount() {
    this.setState({ serieInput: this.props.store.car.vin || this.props.prevData.serieInput })
    this.setState({
      step1ButtonDisabled: !(this.props.prevData.serieInput && this.props.prevData.serieInput.length > 2) && !(this.props.store.car.vin && this.props.store.car.vin.length > 2)
    })
    this.checkKilometreValidity(this.state.kilometrage)
  }

  checkSerieCode = () => {
    const CarDetails = new fetchApiData()
    this.setState({ step1Loading: true })

    CarDetails.getSerie(this.state.serieInput).then(
      data => {
        switch (data.d.ErrorCode) {
          case 0:
            if (this.props.store.listPremiumServices.some(item =>
              (item.codeIntern === 'PC' || item.codeIntern === 'LCV') && item.displayDL)) {
              if (!((data.d.VehicleInfo.LCV === this.props.store.dealer.LCV) || (data.d.VehicleInfo.PC === this.props.store.dealer.PC))) {
                this.setState({
                  showFiltersPopup: true,
                  isVehicleLCV: data.d.VehicleInfo.LCV,
                  isVehiclePC: data.d.VehicleInfo.PC
                })
                document.body.classList.add('no-scroll')
                this.isfiltersPopinOpen = true
              }
            }

            this.props.setVeiculeInfos(data.d.VehicleInfo)
            this.setState({ /*validFirstSection: false,*/ step1Loading: false, serieCodeError: '' })
            this.props.setVeiculeKilo({ contratService: this.state.contratSerivce, kilometrage: this.state.kilometrage, carStep: '2' })
            this.props.updateServicesAfterDataChanged()
            this.isRecallCampagneActivate && this.checkCompagneRappelEligibility()
            !this.isRecallCampagneActivate && !this.isfiltersPopinOpen && this.props.CurrentStepSetAction(4)
            pushEventToGTM({
              pageName: 'car-details',
              eventAction: 'Redirection::Internal::Next_step',
              eventLabel: 'vin'
            })
            break
          default:
            this.setState({ serieCodeError: (data.d.ErrorMessage == 1 ? CONSTANTS.LABELS.vehicule_serial_step1_error_incorrect : CONSTANTS.LABELS.vehicule_serial_step1_error_unknown) })
            this.setState({ step1Loading: false })
            break
        }
      })
      .catch(error => {
        console.log('fait: ', Error)
        this.setState({ step1Loading: false })
      });
  }
  checkCompagneRappelEligibility = () => {
    const cpRappelData = new fetchApiData()
    cpRappelData.getCompagneRappelEligibility(this.state.serieInput).then(
      data => {
        if (data.d.Eligible) {
          this.setState({
            showPopup: true
          });
          document.body.classList.add('no-scroll')
          this.isRecallCompagnePopinOpen = true;
        }
        !this.isRecallCompagnePopinOpen && !this.isfiltersPopinOpen && this.props.CurrentStepSetAction(4)

      })
      .catch(error => {
        console.log('Error: ', error)
        !this.isRecallCompagnePopinOpen && !this.isfiltersPopinOpen && this.props.CurrentStepSetAction(4)
      });
  }

  continueToNextStep(popinName) {
    if (popinName === 'recallCompaingPopin') {
      this.setState({
        showPopup: false
      });
      document.body.classList.remove('no-scroll')
      this.isRecallCompagnePopinOpen = false;
    }
    if (popinName === 'filterPopin') {
      this.setState({
        showFiltersPopup: false
      });
      document.body.classList.remove('no-scroll')
      this.isfiltersPopinOpen = false
    }
    if (!this.isRecallCompagnePopinOpen && !this.isfiltersPopinOpen) this.props.CurrentStepSetAction(4)

  }
  goToDealersLocator = () => {
    this.props.store.listPremiumServices.forEach(item => {
      if (item.codeIntern === 'LCV' && this.state.isVehicleLCV) {
        if (this.props.store.filterDealersBy.indexOf(item.idServicePremium) === -1) {
          this.props.setFilterDealersBy([...this.props.store.filterDealersBy, item.idServicePremium])
        }
      }
      if (item.codeIntern === 'PC' && this.state.isVehiclePC) {
        if (this.props.store.filterDealersBy.indexOf(item.idServicePremium) === -1) {
          this.props.setFilterDealersBy([...this.props.store.filterDealersBy, item.idServicePremium])
        }
      }
    })
    // this.state.isVehicleLCV ? this.props.setFilterDealersBy('LCV') : (this.state.isVehiclePC ? this.props.setFilterDealersBy('PC') : this.props.setFilterDealersBy('ALL'))
    this.props.CurrentStepSetAction(1)
  }
  render() {
    const { ModelLabel, EnergyLabel, BrandLabel } = this.props.store.car
    const popInFilterContent = <div className='warning-filters'>
      <p className='warning-main'>{CONSTANTS.LABELS.vehicule_filter_alert_main}</p>
      <div className='warning-list'>
        <p className='warning-second'>{CONSTANTS.LABELS.vehicule_filter_alert_second}</p>
        <li className='warning-item'><i className='mark-icons cross-icon' /><span className='warning-label'>{CONSTANTS.LABELS.vehicule_filter_alert_warranty} </span> </li>
        <li className='warning-item'><i className='mark-icons cross-icon' /><span className='warning-label'>{CONSTANTS.LABELS.vehicule_filter_alert_maintenance}</span></li>
        <li className='warning-item'><i className='mark-icons cross-icon' /><span className='warning-label'>{CONSTANTS.LABELS.vehicule_filter_alert_recall_campain}</span></li>
        <li className='warning-item'><i className='mark-icons cross-icon' /><span className='warning-label'>{CONSTANTS.LABELS.vehicule_filter_alert_package}</span></li>
      </div>
    </div>


    return (
      <div className='CarDetails-tab-item SerieTab'>


        <p tabIndex="0" className="section-intro" dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.vehicule_label1) }}></p>

        <TabSection
          //order={1}
          title={CONSTANTS.LABELS.vehicule_serial_step1}
          //editMode={!this.state.validFirstSection}
          //enabled={this.state.validFirstSection}
          //EditClick={() => this.setState({ validFirstSection: true })}
          Loading={this.state.step1Loading}
        >
          {/*this.state.validFirstSection && */<>
            <div className='ligne  '>

              <div className='row section-label'>
                <span dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.vehicule_serial_step1_vin) }}></span>
              </div>
              <div className='row section-form'>
                <Input
                  placeholder={CONSTANTS.LABELS.vehicule_serial_step1_example}
                  name={'vinNumber'}
                  ariaLabel={CONSTANTS.LABELS.vehicule_serial_step1_vin}
                  autoComplete={'on'}
                  onChange={(e) => {
                    this.setState({ serieInput: e.target.value })
                    this.props.dataFromChild({
                      serieInput: e.target.value
                    });
                    (e.target.value.trim().length ? this.setState({ step1ButtonDisabled: false }) : this.setState({ step1ButtonDisabled: true }))
                  }}
                  isInvalid={this.state.serieCodeError}
                  Value={this.state.serieInput}
                />
                {/** ************************** Ou se trouve le nemuro de serie ? [For Mobile] *************************/}
                {window.isMobile() != 'desktop' && <div className='row section-infos'>
                  <TabInfoSection
                    title={CONSTANTS.LABELS.vehicule_serial_step1_help1}
                  >

                    <span dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.vehicule_serial_step1_help2) }}></span>
                    <br />
                    <br />
                    <img src={CONSTANTS.SITE_INFO.VINIMAGE} alt={CONSTANTS.LABELS.vehicule_serial_step1_help2} />
                  </TabInfoSection>
                </div>}
                {/** ************************** END- Ou se trouve le nemuro de serie ? [For Mobile] *************************/}

                {/* <div className='form-wrapper'>
                  <Button
                    onClick={() => this.checkSerieCode()}
                    Disabled={this.state.step1ButtonDisabled}
                  >
                    {CONSTANTS.LABELS.common_v2_nextstep}
                  </Button>
                </div> */}
              </div>
            </div>

          </>}
          {/* {!this.state.validFirstSection && <>
            <div className='section-summaryBlock'>
              <p className='section-intro'>{CONSTANTS.LABELS.vehicule_step2_title}
                <strong>{CONSTANTS.SITE_INFO.BRAND_NAME} {ModelLabel} - {EnergyLabel}</strong>
              </p>
            </div>
          </>} */}

          <div className='ligne'>
            <div className='row section-label'>
              <span>{CONSTANTS.LABELS.vehicule_step2_km1}</span>
            </div>

            <div className='row section-form'>
              <Input
                name='distance'
                ariaLabel={CONSTANTS.LABELS.vehicule_step2_km1}
                autoComplete='on'
                Type='tel'
                Selected={this.state.kilometrage}
                onChange={(e) => {
                  this.setState({ kilometrage: e.target.value })
                  this.checkKilometreValidity(e.target.value)
                }}
                isInvalid={this.state.KilometrageError}
              >{CONSTANTS.LABELS.vehicule_step2_km2}
              </Input>
            </div>
          </div>

          <div className='ligne service-contract'>
            <div className='row section-label'>
              <span tabIndex="0">{CONSTANTS.LABELS.vehicule_step2_warranty}</span>
            </div>
            <div className='row section-form'>
              <Radio name='servieContract' id='servieContract-0' label={CONSTANTS.LABELS.vehicule_step2_warranty_no} isChecked={(!this.state.contratSerivce)} onChange={(e) => { this.setState({ contratSerivce: false }) }} />
              <Radio name='servieContract' id='servieContract-1' label={CONSTANTS.LABELS.vehicule_step2_warranty_yes} isChecked={(!!this.state.contratSerivce)} onChange={(e) => { this.setState({ contratSerivce: true }) }} />
            </div>

          </div>
          {// Recall compagne Popup
            this.state.showPopup &&
            <PopUp title={CONSTANTS.LABELS.vehicule_step2recalleligibility}
              content={CONSTANTS.LABELS.vehicule_step2recalleligibilitycontent}
              primaryButtonLabel={CONSTANTS.LABELS.vehicule_step2recalleligibilityagreement}
              handlePrimaryButton={() => { this.continueToNextStep('recallCompaingPopin') }} />
          }
          { // filter LCV/PC incompatibility between vehicle and dealer
            this.state.showFiltersPopup &&
            <PopUp title={CONSTANTS.LABELS.vehicule_filter_alert_title}
              content={popInFilterContent}
              primaryButtonLabel={CONSTANTS.LABELS.vehicule_filter_other_dealer}
              secondaryButtonLabel={CONSTANTS.LABELS.vehicule_filter_ignore}
              handlePrimaryButton={() => this.goToDealersLocator()}
              handleSecondaryButton={() => { this.continueToNextStep('filterPopin') }} />
          }
          {/** ************************** Ou se trouve le nemuro de serie ? [For Desktop] *************************/}

          {window.isMobile() == 'desktop' && <div className='section-infos serieCode'>
            <TabInfoSection
              title={CONSTANTS.LABELS.vehicule_serial_step1_help1}
            >
              {CONSTANTS.LABELS.vehicule_serial_step1_help2}
              <br />
              <br />
              <img src={CONSTANTS.SITE_INFO.VINIMAGE} />
            </TabInfoSection>
          </div>}
          {/** ************************** END- Ou se trouve le nemuro de serie ? [For Desktop] *************************/}
          <div className='ligne'>
            <div className='row section-label' />
            <div className='row section-form'>
              <Button
                //linkTo={CONSTANTS.SITE_ROUTS.SERVICESPAGE}
                onClick={() => {
                  // this.checkData();
                  this.checkSerieCode();
                }}
                Disabled={this.state.step2ButtonDisabled || this.state.step1ButtonDisabled}
              > {CONSTANTS.LABELS.common_v2_nextstep}
              </Button>
            </div>
          </div>

        </TabSection>

        {/* <TabSection
          order={2}
          title={CONSTANTS.LABELS.vehicule_step2}
          enabled={!this.state.validFirstSection}
        >

          <div className='ligne'>
            <div className='row section-label'>
              <span>{CONSTANTS.LABELS.vehicule_step2_km1}</span>
            </div>

            <div className='row section-form'>
              <Input
                name='distance'
                Type='tel'
                Selected={this.state.kilometrage}

                onChange={(e) => {
                  this.setState({ kilometrage: e.target.value })

                  if (e.target.value.trim().length &&
                        Number(e.target.value) > 999999
                  ) {
                    this.setState({
                      step2ButtonDisabled: true,
                      KilometrageError: CONSTANTS.LABELS.vehicule_step2_error_limitednumbers
                    })
                  } else if (
                    e.target.value.trim().length &&
                        !(/^[0-9]*$/.test(e.target.value))
                  ) {
                    this.setState({
                      step2ButtonDisabled: true,
                      KilometrageError: CONSTANTS.LABELS.vehicule_step2_error_numbersonly
                    })
                  } else {
                    this.setState({ step2ButtonDisabled: false, KilometrageError: false })
                  }
                }}
                isInvalid={this.state.KilometrageError}
              >{CONSTANTS.LABELS.vehicule_step2_km2}
              </Input>
            </div>
          </div>

          <div className='ligne service-contract'>
            <div className='row section-label'>
              <span>{CONSTANTS.LABELS.vehicule_step2_warranty}</span>
            </div>
            <div className='row section-form'>
              <Radio name='servieContract' id='servieContract-0' label={CONSTANTS.LABELS.vehicule_step2_warranty_no} isChecked={(!this.state.contratSerivce)} onChange={(e) => { this.setState({ contratSerivce: false }) }} />
              <Radio name='servieContract' id='servieContract-1' label={CONSTANTS.LABELS.vehicule_step2_warranty_yes} isChecked={(!!this.state.contratSerivce)} onChange={(e) => { this.setState({ contratSerivce: true }) }} />
            </div>

          </div>
          <div className='ligne'>
            <div className='row section-label' />
            <div className='row section-form'>
              <div className='form-wrapper'>
                <Button
                  linkTo={CONSTANTS.SITE_ROUTS.SERVICESPAGE}
                  onClick={() => {
                    
                  }}
                  Disabled={this.state.step2ButtonDisabled}
                >{CONSTANTS.LABELS.common_v2_nextstep}
                </Button>
              </div>
            </div>
          </div>

        </TabSection> */}

      </div>
    )
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(SerieTab)
